import { Button } from '@admin-panel/ui';
import type { OccasionTreeItemType } from '../../../schemas/styling';
import OccasionFilter from '../../Looks/OccasionFilter';
import { RackLottie } from '@admin-panel/components';
import { swallowEvent } from '@admin-panel/utils';

type LookGroupsToolbarProps = {
  occasions: Array<OccasionTreeItemType>;
  selectedOccasionId: number | null;
  selectedSubOccasionIds: Array<number>;
  isFiltering?: boolean;
  onOccasionFilterChange: (selection: {
    occasionId: number | null;
    subOccasionIds: Array<number>;
  }) => void;
};

const LookGroupsToolbar = ({
  occasions,
  selectedOccasionId,
  selectedSubOccasionIds,
  isFiltering = false,
  onOccasionFilterChange,
}: LookGroupsToolbarProps) => {
  if (occasions.length === 0) {
    return null;
  }

  const hasActiveFilter = selectedOccasionId !== null || selectedSubOccasionIds.length > 0;

  return (
    <div className="grid gap-2 px-3 py-2">
      <div>
        <OccasionFilter
          occasions={occasions}
          selectedOccasionId={selectedOccasionId}
          selectedSubOccasionIds={selectedSubOccasionIds}
          onChange={onOccasionFilterChange}
        />
      </div>

      <div className="flex min-h-8 items-center">
        {isFiltering && (
          <div
            onClick={swallowEvent}
            className="fixed inset-0 z-1000 flex h-dvh w-screen cursor-progress items-center justify-center backdrop-blur-[2px]"
          >
            <RackLottie height={300} width={300} />
          </div>
        )}

        {hasActiveFilter ? (
          <Button
            type="button"
            variant="ghost"
            size="small"
            className="w-auto"
            onClick={() => onOccasionFilterChange({ occasionId: null, subOccasionIds: [] })}
          >
            Clear occasion filter
          </Button>
        ) : (
          <div className="h-8" />
        )}
      </div>
    </div>
  );
};

export default LookGroupsToolbar;
